<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <form-component
        :disabled="disabled"
        :data="data"
        :model="formModel"
        @change="handleFormData"
        @onAutoSave="mixAutoSave"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'
import { ModelRFQ3, ServiceRFQ3s } from '@/services/RFQ3s'

export default {
  name: 'EditorRFQ3sParts',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'form-component': () => import(/* webpackChunkName: 'RFQ3sParts' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  computed: {
    formTitle () {
      return this.formData.rfqid || this.checkEs6AndRun(this.title)
    },
    apiAutoSave () {
      return `${ServiceRFQ3s.apiPatch}/${this.currentID}`
    },
    isAvailableToSave () {
      return this.hasCreateNew
    }
  },
  methods: {
    formModel () {
      return ModelRFQ3()
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    }
  }
}
</script>
